module.exports = __webpack_public_path__ + "static/media/ruler-selected.2f1d1ad9.svg";